/**
 * EOFY Bonus Packs — Countdown Timer & Scroll Animations
 * Vanilla JS, no dependencies, Shopify OS 2.0 compatible.
 * Re-initialises on theme editor section load/select for live preview.
 */
(function () {
  'use strict';

  function initCountdowns(root) {
    var countdownEls = root.querySelectorAll('[data-eofy-countdown]');

    countdownEls.forEach(function (el) {
      if (el.dataset.eofyInitialised === 'true') return;
      el.dataset.eofyInitialised = 'true';

      var endAttr = el.getAttribute('data-end');
      if (!endAttr) return;

      var endDate = new Date(endAttr);
      if (isNaN(endDate.getTime())) return;

      var timerWrap = el.querySelector('[data-eofy-countdown-timer]');
      var endedEl = el.querySelector('[data-eofy-countdown-ended]');

      var daysEl = el.querySelector('[data-eofy-days]');
      var hoursEl = el.querySelector('[data-eofy-hours]');
      var minutesEl = el.querySelector('[data-eofy-minutes]');
      var secondsEl = el.querySelector('[data-eofy-seconds]');

      var intervalId = null;

      function pad(num) {
        return String(num).padStart(2, '0');
      }

      function showEnded() {
        if (timerWrap) timerWrap.hidden = true;
        var label = el.querySelector('.eofy-countdown__label');
        if (label) label.hidden = true;
        if (endedEl) endedEl.hidden = false;
        if (intervalId) clearInterval(intervalId);
      }

      function tick() {
        var now = new Date().getTime();
        var distance = endDate.getTime() - now;

        if (distance <= 0) {
          showEnded();
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      intervalId = setInterval(tick, 1000);

      // Clean up interval if the section is removed (theme editor)
      el.eofyCountdownInterval = intervalId;
    });
  }

  function initScrollAnimations(root) {
    var animatedEls = root.querySelectorAll('[data-eofy-animate]');
    if (!animatedEls.length) return;

    animatedEls.forEach(function (el) {
      var delay = el.getAttribute('data-eofy-delay');
      if (delay) {
        el.style.setProperty('--eofy-delay', delay);
      }
    });

    if (!('IntersectionObserver' in window)) {
      animatedEls.forEach(function (el) {
        el.classList.add('eofy-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('eofy-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSection(section) {
    initCountdowns(section);
    initScrollAnimations(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('.eofy-bonus-packs-section, .eofy-section');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support — re-init when this section loads/reorders
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.eofy-section');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target.querySelector('.eofy-section');
    if (section) initSection(section);
  });
})();